import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    useFetch,
    useForm,
    useGrid,
    useModal,
    useResource,
    useStore,
    useToast,
    usePage,
    useAuth,
    usePopup,
} from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Button, FormControl } from "@/comn/components";
import {
    APIS,
    URLS,
    SF_USR_FRGNR_FORM,
    SG_VHCL_INFO_LIST,
    AddStr,
} from "@/tra/tancis/ptli/usr/frgnr/services/PtliUsrFrgnrService";

import { PTLI0919004S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919004S";
import { PTLI0919005S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919005S";

/*
 * Foreign Transporter Edit
 * !== 외국인 운송업체 수정 ==!
 */
export const PTLI0919006S = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_cgmi0067", "auth_ptli0042", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const location = useLocation();
    const [cntyNm, setCntyNm] = useState(); // Company Process State Code !== 업체 프로세스 상태 코드 ==!
    const [lcneAplyPrcssStatCd, setLcneAplyPrcssStatCd] = useState(); // Company Process State Code !== 업체 프로세스 상태 코드 ==!

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "LCM0003" }, { area: "cntyCd" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Foreign Transporter Details !== 외국인 운송업체 상세 Form ==!
        usrFrgnrForm: useForm({
            defaultSchema: SF_USR_FRGNR_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Vehicle Information List !== 차량 정보 목록 ==!
        vhclInfoList: useGrid({
            defaultSchema: SG_VHCL_INFO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /* Check for PIN Number required turn off !== PIN 확인 필수값 해제 ==! */
    const hasPin = () => {
        const pin = form.usrFrgnrForm.getValue("pin");
        if (comnUtils.isEmpty(pin)) {
            form.usrFrgnrForm.setSchema("pin", { required: false });
        }
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get -
        getFrgnrDtl: useFetch({
            api: () => {
                return APIS.getFrgnrDtl(location.state);
            },
            enabled: true,
            onSuccess: (data) => {
                form.usrFrgnrForm.setValues({
                    ...data.frgnrDetail.content,
                });

                const postCntyNm = data.frgnrDetail.content.cntyNm;
                const lcneAplyPrcssStatCd = data.frgnrDetail.content.lcneAplyPrcssStatCd;
                setCntyNm(postCntyNm);
                setLcneAplyPrcssStatCd(lcneAplyPrcssStatCd);

                hasPin();
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.00006",
                });
            },
        }),
        // GET - Foreign Vehicle List !== 외국 차량 신청 목록 조회 ==!
        getFrgnrVhclList: useFetch({
            api: (page = grid.vhclInfoList.page) => {
                return APIS.getFrgnrVhclList(location.state, page, grid.vhclInfoList.size);
            },
            enabled: !!location.state,
            key: [grid.vhclInfoList.page, grid.vhclInfoList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    page: grid.vhclInfoList.page,
                    size: grid.vhclInfoList.size,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.00006",
                });
            },
            showToast: true,
        }),
        // EDIT - Foreign Transporter Modify  !== 외국인 운송업체 수정 ==!
        updateFrgnr: useFetch({
            api: (data) => {
                return APIS.updateFrgnr(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        navigate(URLS.ptli0919001s);
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // GET - Foreign Vehicle List !== 외국 차량 신청 목록 조회 ==!
        getFrgnrVhclList: (page: number = 0) => {
            grid.vhclInfoList.setPage(page);
            fetch.getFrgnrVhclList.fetch(page);
        },
        // EDIT - Foreign Transporter Modify  !== 외국인 운송업체 수정 ==!
        updateFrgnr: (type: any) => {
            form.usrFrgnrForm.handleSubmit(
                (data) => {
                    let reqData = {};

                    if (type == "save") {
                        reqData = {
                            ...data,
                            lcneAplyPrcssStatCd: "1",
                        };
                    } else if (type == "submit") {
                        reqData = {
                            ...data,
                            lcneAplyPrcssStatCd: "A",
                        };
                    }

                    modal.openModal({
                        content: "msg.00101",
                        onConfirm: () => {
                            fetch.updateFrgnr.fetch(reqData);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        grid_vhclInfoList: {
            cell: {
                vhclRgsrNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Link
                            to={""}
                            onClick={() => {
                                const handleSave = (data: any) => {
                                    modal.closeModal();
                                };
                                modal.openModal({
                                    content: (
                                        <PTLI0919005S
                                            data={{
                                                coTin: rowValues.coTin,
                                                appNo: rowValues.appNo,
                                                amdDgr: rowValues.amdDgr,
                                                lcneYy: rowValues.lcneYy,
                                                vhclRgsrNo: rowValues.vhclRgsrNo,
                                                cardRgsrNo: rowValues.cardRgsrNo,
                                            }}
                                            handleSave={handleSave}
                                        />
                                    ),
                                    size: "md",
                                    draggable: true,
                                    close: false,
                                });
                            }}
                        >{`${rowValues.vhclRgsrNo}`}</Link>
                    );
                },
            },
        },
    };

    let [physPlotNm, physBlckNm, physStretNm] = form.usrFrgnrForm.watch(["physPlotNm", "physBlckNm", "physStretNm"]);
    let [postBoxNo, postRegnNm, postDstrNm] = form.usrFrgnrForm.watch(["postBoxNo", "postRegnNm", "postDstrNm"]);

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getFrgnrVhclList(pgeStore?.page);
    }, []);

    useEffect(() => {
        form.usrFrgnrForm.setValue("physAddr", AddStr([physPlotNm, physBlckNm, physStretNm]));
        form.usrFrgnrForm.setValue("postAddr", AddStr([postBoxNo, postRegnNm, cntyNm]));
    }, [physPlotNm, physBlckNm, physStretNm, postBoxNo, postRegnNm, postDstrNm]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col" gap={4}>
                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_DTL")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>

                                    <Group.Section>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.usrFrgnrForm.schema.pin}
                                                readOnly={true}
                                            ></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.usrStatCd}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            {/*<Group.Control {...form.usrFrgnrForm.schema.coTin}></Group.Control>*/}
                                            <Group.Control {...form.usrFrgnrForm.schema.cstmLcneNo}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control
                                                {...form.usrFrgnrForm.schema.lcneYy}
                                                readOnly={true}
                                            ></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.lcneVldtyDays}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.rgsrTrdrNm}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.bizTpCd}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.trprOwrsTrckNo}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.bizLcneNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.bizLcneIssDtm}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.preLcneNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.preLcneIssDtm}></Group.Control>
                                        </Group.Row>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>

                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_CTS")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>

                                    <Group.Section>
                                        <Group.Cell root>
                                            <Group.Cell header>{t("L_PHYS_ADDR")}</Group.Cell>
                                            <Group.Cell size={10}>
                                                <Group.Cell header size={2}>
                                                    {t("L_PLOT")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physPlotNm} />
                                                </Group.Cell>

                                                <Group.Cell header size={2}>
                                                    {t("L_BLCK")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physBlckNm} />
                                                </Group.Cell>

                                                <Group.Cell header size={2}>
                                                    {t("L_STRET")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physStretNm} />
                                                </Group.Cell>

                                                <Group.Cell size={10}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physAddr} />
                                                </Group.Cell>
                                            </Group.Cell>
                                        </Group.Cell>

                                        <Group.Cell root>
                                            <Group.Cell header>{t("L_POST_ADDR")}</Group.Cell>
                                            <Group.Cell size={10}>
                                                <Group.Cell header size={2}>
                                                    {t("L_BOX_NO")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postBoxNo} />
                                                </Group.Cell>

                                                <Group.Cell header required size={2}>
                                                    {t("L_REGN")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postRegnNm} />
                                                </Group.Cell>

                                                <Group.Cell header required size={2}>
                                                    {t("L_CNTY")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl
                                                        {...form.usrFrgnrForm.schema.postDstrNm}
                                                        callback={(data) => setCntyNm(data.label)}
                                                    />
                                                </Group.Cell>

                                                <Group.Cell size={10}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postAddr} />
                                                </Group.Cell>
                                            </Group.Cell>
                                        </Group.Cell>

                                        <Group.Cell root>
                                            <Group.Cell required header>
                                                {t("L_EML_ADDR")}
                                            </Group.Cell>
                                            <Group.Cell size={10}>
                                                <FormControl {...form.usrFrgnrForm.schema.emlAddr} />
                                            </Group.Cell>
                                        </Group.Cell>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>
                    </Layout>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0919001s);
                        }}
                    />
                </Layout.Left>

                {lcneAplyPrcssStatCd != "A" && (
                    <Layout.Right>
                        <Button
                            role="save"
                            onClick={() => {
                                handler.updateFrgnr("save");
                            }}
                        />
                        <Button
                            role="submit"
                            onClick={() => {
                                handler.updateFrgnr("submit");
                            }}
                        />
                    </Layout.Right>
                )}
            </Layout>

            {lcneAplyPrcssStatCd == "M" && (
                <>
                    <Group>
                        <Group.Body>
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={t("T_VHCL_INFO")} titleSize={2}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Grid
                                {...grid.vhclInfoList.grid}
                                data={fetch.getFrgnrVhclList.data?.frgnrVhclList}
                                render={render.grid_vhclInfoList}
                            />
                        </Group.Body>
                    </Group>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="new"
                                onClick={() => {
                                    const handleSave = (data: any) => {
                                        // Modal 창에서 받은 데이터 확인
                                        if (data == "save") {
                                            fetch.getFrgnrVhclList.fetch();
                                        }
                                    };

                                    modal.openModal({
                                        content: (
                                            <PTLI0919004S
                                                data={{
                                                    coTin: form.usrFrgnrForm.getValue("coTin"),
                                                    appNo: form.usrFrgnrForm.getValue("appNo"),
                                                    cstmLcneNo: form.usrFrgnrForm.getValue("cstmLcneNo"),
                                                    lcneYy: form.usrFrgnrForm.getValue("lcneYy"),
                                                    bizLcneIssDtm: form.usrFrgnrForm.getValue("bizLcneIssDtm"),
                                                }}
                                                handleSave={handleSave}
                                            />
                                        ),
                                        size: "md",
                                        draggable: true,
                                        close: false,
                                    });
                                }}
                            />
                        </Layout.Left>
                    </Layout>
                </>
            )}
        </Page>
    );
};
